<div class="stepper-wrapper">
  <p-stepper [(value)]="currentStep" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Pedidos</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Detalle del Pedido</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="stepPanel.PanelOne">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="panel-content">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [data]="data"
              [isMultipleSelect]="false" [headers]="header" [previousFilters]="filters"
              [initialSelectionId]="orderIdFromConfig" [dataKey]="'orderId'" (onRecoverData)="getOrdersForSelection()"
              (selectionChange)="selectionChange($event)" (onPageChange)="onPageChange($event)"
              (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="d-flex justify-content-end">
            <app-custom-button [width]="'7'" [severity]="'contrast'" [label]="'Siguiente'" [icon]="'pi pi-arrow-right'"
              (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="panel-content">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table #tableDetail [showRecover]="true" [data]="dataDetail" [headers]="headerDetail"
              [showCheckbox]="true" [isMultipleSelect]="false" (onRecoverData)="getOrderDetailsForSelection()"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="fd-flex lex justify-start">
            <app-custom-button [width]="'7'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
              (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>